import React, { useEffect, useLayoutEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import TextArea from "../../../../../stories/TextArea/TextArea";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { Button } from "../../../../../stories/Button/Button";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";

const Data = [
  {
    desc: "CCTV",
    request_for_quotation_no: "CCTV002",
    group: "camera",
    category: "surveillance Equipment",
    unit: "No.",
    total_items_quoted: 18,
    approx_value: 9,
    sgst: 9,
    mail_status: "sent",
  },
  {
    desc: "CCTV",
    request_for_quotation_no: "CCTV002",
    group: "camera",
    category: "surveillance Equipment",
    unit: "No.",
    total_items_quoted: 18,
    approx_value: 9,
    sgst: 9,
    mail_status: "pending",
  },
];
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const View = ({ setModalFlag }: Props) => {
  const { Purchase } = useAssetTableJson();

  const dynamicHeaders: TableHeaderProps[] = Purchase.Quotation.List
  .filter((header) => header.field !== "actions" && header.field !== "mail_status")
  .map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    cellClassName: header.cellClassName,
    hideable:header.hideable
  }));

  const columns: GridColDef[] = [...dynamicHeaders];
  const rows: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        rfq_date: "01-11-2024",
        request_for_quotation_no: data.request_for_quotation_no,
        total_items_quoted: data.total_items_quoted,
        approx_value: data.approx_value,
        late_date_for_submission: "01-11-2024",
        rfq_prepared_by: "fghj",
        rfq_authorized_by: "iuyt",
        remarks: "remarks",
        mail_status: data.mail_status,
      };
    }) || [];

    const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.VIEW_REQUEST_QUOTATION
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.VIEW_REQUEST_QUOTATION,
      JSON.stringify(newModel)
    );
  };
  return (
    <>
      <div className="quotation__view">
        <div className="quotation__view--title">
          <Title>View Request Quotation</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>

        <div className="quotation__add--select row g-0">
          <div className="col-7">
            <div className="label-grid">
              <Label>Request for Quotation No.</Label>
              <Input disabled />
            </div>
          </div>
          <div className="col"></div>
          <div className="col-4 flex-end">
            <Label>Date</Label>
            <Input type="date" />
          </div>
        </div>

        <div className="quotation__view--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            hideFooter
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel
              }
            }}
          />
        </div>
        <div className="quotation__add--datablock row g-0">
          <div className="col quotation__add--datablock--frame">
            <div className="quotation__add--datablock--frame--grid">
              <Label>Last Date for Submission</Label>
              <Input type="date" disabled/>
              <Label>RFQ Prepared By</Label>
              <Input disabled/>
              <Label>RFQ Authorized By</Label>
              <Input disabled />
            </div>
          </div>
          <div className="col quotation__add--datablock--frame">
            <div className="quotation__add--datablock--frame--grid">
              <Label>General Terms & Condition</Label>
              <TextArea rows={3} disabled />
              <Label>General Payment Terms</Label>
              <TextArea rows={3} disabled/>
            </div>
          </div>
          <div className="col quotation__add--datablock--frame">
            <div className="quotation__add--datablock--frame--grid">
              <Label>Remarks</Label>
              <TextArea rows={3} disabled />
            </div>
          </div>
        </div>
        <Button mode="cancel" onClick={()=>setModalFlag(false)}/>
      </div>
    </>
  );
};

export default View;
